module.exports = __webpack_public_path__ + "static/img/cont2202.13de1ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2202.jpg
// module id = WEYs
// module chunks = 0